import { CompanyOverrides, DemoCategory } from './types'
import { api } from '../api'
import { getMockData } from './mocks'
import { clearDemoData, setDemoData } from 'api/demo/utils'
import { createMockLocationsForCategory } from 'api/demo/mocks/createLocation'
import { createMockPositionsForCategory } from 'api/demo/mocks/createPosition'
import { createMockWorkersForCategory } from 'api/demo/mocks/createWorkers'
import { createMockRostersForCategory } from 'api/demo/mocks/createRoster'
import { createMockShiftsForCategory } from 'api/demo/mocks/createShift'
import { createDemoAssignment } from 'api/demo/mocks/createAssignment'
import { companyMembers } from 'api/demo/data/companyMembers'
import { createMockInsightsForCategory } from './mocks/createInsights'
import { createDemoPulseFillData } from './data/pulse'
export { isDemoMode } from './utils'
export * from './demoCompany'

let interceptorId: number

export function createApiInterceptor() {
  interceptorId = api.interceptors.request.use(async (config) => {
    const mockData = await getMockData(config)
    if (mockData !== undefined) {
      config.adapter = (config) => {
        return Promise.resolve({
          data: mockData,
          status: 200,
          statusText: 'OK',
          headers: {},
          config,
        })
      }
    }
    return config
  })
}

export function removeApiInterceptor() {
  if (interceptorId) {
    api.interceptors.request.eject(interceptorId)
  }
}

export async function activateDemoMode(
  category: DemoCategory,
  companyOverrides?: CompanyOverrides
) {
  const workers = await createMockWorkersForCategory()
  const locations = createMockLocationsForCategory(category)
  const positions = createMockPositionsForCategory(category)
  const { shifts, supervisors } = createMockShiftsForCategory(
    locations,
    positions,
    workers
  )
  const baseShiftId = Math.max(...shifts.map((s) => s.id), 0) + 1
  const baseWorkId =
    shifts.reduce((max, s) => {
      const ids = (s.work || []).map((w) => w.id)
      return Math.max(max, ...ids, 0)
    }, 0) + 1
  const baseCalloutId =
    shifts.reduce((max, s) => {
      const ids = (s.work || []).flatMap((w) =>
        (w.callouts || []).map((c) => c.id)
      )
      return Math.max(max, ...ids, 0)
    }, 0) + 1
  const { assignment, shifts: assignmentShifts } = createDemoAssignment(
    baseShiftId,
    baseWorkId,
    baseCalloutId,
    locations[0],
    positions[0],
    workers
  )
  shifts.push(...assignmentShifts)
  const rosters = createMockRostersForCategory(category, workers)
  const insights = createMockInsightsForCategory(category, workers)
  const pulseFillData = createDemoPulseFillData(positions, locations, workers)

  const demoData = {
    category,
    locations,
    positions,
    workers,
    rosters,
    shifts,
    supervisors,
    companyMembers,
    assignments: [assignment],
    insights,
    companyOverrides,
    pulseFillData,
  }
  setDemoData(demoData)
  // set demo mode on
  createApiInterceptor()
}

export function reactivateDemoMode() {
  createApiInterceptor()
}

export function deactivateDemoMode() {
  clearDemoData()
  removeApiInterceptor()
}
